import React from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Index() {
    const navigate = useNavigate()
    return (
        <Layout nav={false}>
            <HeaderMain lable="ثبت شکایت" />
            <div className="filters-main">
                <div className="box">
                    <div className={'form-group my-3'}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <label>نام و نام خانوادگی</label>
                        </div>
                        <input name="name" type="text" className={'form-control '} />
                    </div>
                    <div className={'form-group my-3'}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <label>شماره همراه</label>
                        </div>
                        <input name="number" type="text" className={'form-control '} />
                    </div>
                    <div className={'form-group my-3'}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <label>متن شکایت</label>
                        </div>
                        <input name="texy" type="text" className={'form-control '} />
                    </div>
                </div>


                <button onClick={() => { toast.success('درخواست شما با موفقیت ثبت شد'); navigate('/') }} className="btn mt-5">ثبت درخواست</button>
            </div>
        </Layout>
    )
}

export default Index